import { render } from "./QbTables.vue?vue&type=template&id=11d68d6a&scoped=true"
import script from "./QbTables.vue?vue&type=script&lang=js"
export * from "./QbTables.vue?vue&type=script&lang=js"

import "./QbTables.vue?vue&type=style&index=0&id=11d68d6a&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d68d6a"]])

export default __exports__